import { JeecgListMixin } from "@/utils/JeecgListMixin";
import { getAction } from "@/api/manage";
import JDictSelectTag from "@/components/jeecg/JDictSelectTag";
export default {
  name: "Question",
  mixins: [JeecgListMixin],
  components: {
    JDictSelectTag: JDictSelectTag
  },
  data: function data() {
    return {
      paperDataSource: [],
      columns: [{
        title: '类型',
        align: "center",
        dataIndex: 'paperType_dictText',
        width: 120
      }, {
        title: '试卷名',
        align: "center",
        dataIndex: 'paperName',
        customRender: function customRender(v, r) {
          return r.examName || r.paperName;
        }
      }, {
        title: '开放时间',
        align: "center",
        dataIndex: 'openMethod',
        width: 180,
        customRender: function customRender(v, r) {
          if (v == 1) {
            return "长期有效";
          } else if (v == 2) {
            return r.startTime.split(" ")[0] + " - " + r.endTime.split(" ")[0];
          } else if (v == 3) {
            return '通过上一级别';
          }
        }
      },
      // {
      //     title:'来源',
      //     align:"center",
      //     dataIndex: 'paperType_dictText',
      //   },
      {
        title: "操作",
        dataIndex: "action",
        fixed: "right",
        align: "center",
        width: 100,
        scopedSlots: {
          customRender: "action"
        }
      }],
      pagination: {
        onChange: function onChange(page) {
          console.log(page);
        },
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: function showTotal(total, range) {
          return range[0] + "-" + range[1] + " 共" + total + "条";
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      },
      loading: true,
      queryParam: {
        isSimulation: 1,
        paperType: undefined,
        userPaperStatus: ''
      },
      disableMixinCreated: true
    };
  },
  created: function created() {
    this.getPaperList();
  },
  methods: {
    handleChangeType: function handleChangeType(v) {
      this.queryParam.paperType = v;
      this.getPaperList();
    },
    handleChangeStatus: function handleChangeStatus(v) {
      this.queryParam.userPaperStatus = v;
      this.getPaperList();
    },
    getPaperList: function getPaperList() {
      var _this = this;
      this.loading = true;
      this.paperDataSource = [];
      getAction('/teaching/teachingPaper/minePaperList', {
        isSimulation: this.queryParam.isSimulation,
        paperType: this.queryParam.paperType,
        userPaperStatus: this.queryParam.userPaperStatus,
        pageSize: 999
      }).then(function (res) {
        console.log(res);
        if (res.success) {
          for (var i in res.result) {
            var p = res.result[i];
          }
          _this.paperDataSource = res.result;
          _this.pagination.total = res.result.length;
        }
        _this.loading = false;
      });
    },
    getUserPaperStatus: function getUserPaperStatus(status) {
      console.log(status);
      if (status == null) {
        return ['gray', this.$t('exam.noAnswer')];
      }
      if (status == 0) {
        return ['orange', this.$t('exam.saved')];
      }
      if (status == 1) {
        return ['green', this.$t('exam.nosubmittedAnswer')];
      }
      if (status == 3) {
        return ['blue', this.$t('exam.Corrected')];
      }
      return ['gray', status];
    },
    toPaper: function toPaper(info) {
      var route = this.$router.resolve({
        path: '/examine',
        query: {
          id: info.paperId,
          departId: info.departId,
          paperId: info.paperId
        }
      });
      window.open(route.href, '_blank');
    },
    toMyPaperAnswer: function toMyPaperAnswer() {
      this.$router.push({
        name: 'myPaperAnswer'
      });
    }
  }
};